export default function formatDate(date, format = 'date') {
  if (!date) return 'N/A';
  
  const event = new Date(date);
  
  if (isNaN(event.getTime())) {
    return 'Invalid Date';
  }
  
  switch (format) {
    case 'time':
      return event.toLocaleTimeString('en-US', { 
        hour: '2-digit', 
        minute: '2-digit',
        hour12: true 
      });
    case 'datetime':
      return event.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    case 'date':
    default:
      return event.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
  }
}
